import ascending from "./ascending";

export default function(series) {
  return ascending(series).reverse();
}



//////////////////
// WEBPACK FOOTER
// /~/d3-shape/src/order/descending.js
// module id = bXKc
// module chunks = 0